export const ACTIONS = {
  plan_visit: {
    title: "Plan your visit",
    intro: "Let us know when you're coming and we'll be ready to welcome you.",
    fields: [
      { key: "service", label: "Which service would you like to join?", type: "service" },
      { key: "guests", label: "How many will be coming with you?", placeholder: "e.g. 2" },
    ],
  },
  talk_pastor: {
    title: "Talk with a pastor",
    intro: "A pastor or leader would love to listen, encourage and pray with you.",
    fields: [{ key: "topic", label: "What's on your heart? (optional)", placeholder: "Questions, prayer, life..." }],
  },
  victory_group: {
    title: "Join a Victory Group",
    intro: "We'll gladly help you find a group of friends to grow with.",
    fields: [
      { key: "area", label: "Your area / barangay", placeholder: "e.g. BF Homes" },
      { key: "schedule", label: "Best day and time for you", placeholder: "e.g. Weeknights" },
    ],
  },
  be_discipled: {
    title: "I want to be discipled",
    intro: "It would be our joy to walk with you as you grow in Christ.",
    fields: [{ key: "area", label: "Your area / barangay", placeholder: "e.g. Sucat" }],
  },
  make_disciples: {
    title: "Make disciples",
    intro: "Thank you for your heart to help others follow Jesus. We'd love to help you take the next step.",
    fields: [{ key: "experience", label: "Are you leading a group right now?", type: "select", options: ["Not yet", "Yes, I lead a Victory Group", "I'm assisting a leader"] }],
  },
  journey: {
    title: "Discipleship Journey",
    intro: "Sign up and we'll gladly let you know when the next class begins.",
    fields: [{ key: "progress", label: "Where are you on the Journey?", type: "select", options: ["Just starting", "Already in progress", "Not sure yet"] }],
  },
  serve: {
    title: "Serve in a ministry",
    intro: "Thank you for your willingness to serve! A ministry leader will gladly reach out to you.",
    fields: [{ key: "ministry", label: "Ministry you're interested in", type: "ministry" }],
  },
  pastoral_care: {
    title: "Pastoral care request",
    intro: "We're here for you in every season, in celebration and in grief.",
    fields: [
      { key: "care_type", label: "How can we care for you?", type: "select", options: ["Wedding", "Child Dedication", "Funeral / Memorial", "Counseling", "Other"] },
      { key: "preferred_date", label: "Preferred date (if any)", placeholder: "e.g. Dec 14, 2026" },
    ],
  },
};
